import { gql } from '@apollo/client';

export const GET_BAKER_USER = gql`
  query GetBakerUser {
    bakerUser {
      email
      profile
      inventory
      loans
      lseg
      dailyPricing
      reports
      admin
      portfolios
      cashFlows
      swapIQ
      houstonTrust
      empyreanImport
      yieldBookMonitor
    }
  }
`;
